var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@appspotr/ui-kit';
import { P } from '../../UI-helpers/typography';
import { Input } from '../../Forms/Fields';
import { Navigate } from 'react-router-dom';
import { InputContainer, CreateAnAccount, AllRightWrapper, ForgetTextWrapper, LoginFormContainer, LoginValidationText, ForgetAndCreateAccount, LoginValidationTextIcon, LoginValidationTextMessage, } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/pro-regular-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/pro-regular-svg-icons/faEyeSlash';
import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons/faExclamationCircle';
import commonMessages from '../../../message.common';
var LoginForm = /** @class */ (function (_super) {
    __extends(LoginForm, _super);
    function LoginForm(props) {
        var _this = _super.call(this, props) || this;
        _this.handleEmailChange = function (e) {
            var _a;
            _this.setState({ email: ((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) || '', isFormSubmitted: false });
        };
        _this.handlePasswordChange = function (e) {
            var _a;
            _this.setState({
                password: ((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) || '',
                isFormSubmitted: false,
            });
        };
        // Submit login on enter keypress
        _this.handleEnterKeyPress = function (e) {
            if (e.keyCode !== 13 ||
                !_this.state.email ||
                !_this.state.password ||
                _this.state.isFormSubmitted) {
                return;
            }
            _this.onUserLoginSubmit(e);
        };
        _this.onUserLoginSubmit = function (e) {
            e.preventDefault();
            _this.setState({
                isFormSubmitted: true,
            });
            var _a = _this.state, email = _a.email, password = _a.password;
            var urlParam = _this.props.urlParam.split('?')[1];
            _this.props.onLogin({ email: email, password: password, code: '', urlParam: urlParam });
        };
        _this.createAnAccount = function () {
            _this.setState({
                redirect: true,
            });
        };
        _this.state = {
            isFormSubmitted: false,
            email: '',
            password: '',
            showPassword: false,
            redirect: false,
            showVerificationPassword: false,
        };
        return _this;
    }
    LoginForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, email = _a.email, password = _a.password, showPassword = _a.showPassword;
        var _b = this.props, isPrivacy = _b.isPrivacy, isTerms = _b.isTerms, isTokenExpired = _b.isTokenExpired, welcomeMessage = _b.welcomeMessage;
        if (this.state.redirect) {
            return _jsx(Navigate, { to: "/signup" });
        }
        this.props.user.authentication_error &&
            this.state.isFormSubmitted &&
            this.setState({
                isFormSubmitted: false,
            });
        return (_jsxs(LoginFormContainer, { children: [_jsx(InputContainer, { children: _jsx(Input, { wide: true, type: "text", placeholder: "Email", name: "email", login: true, value: email, onKeyDown: this.handleEnterKeyPress, onChange: this.handleEmailChange }) }), _jsx(InputContainer, { children: _jsx(Input, { placeholder: "Password", onChange: this.handlePasswordChange, value: password, login: true, withPassword: true, onKeyDown: this.handleEnterKeyPress, type: showPassword ? 'text' : 'password', loginIconSuffix: showPassword ? faEyeSlash : faEye, onClickIconSuffix: function () {
                            _this.setState({ showPassword: !showPassword });
                        } }) }), _jsx(Button, __assign({ style: {
                        justifyContent: 'center',
                        width: '100%',
                    }, type: "primary", disabled: this.state.isFormSubmitted, onClick: this.onUserLoginSubmit }, { children: "Login" })), this.props.user.authentication_error ? (_jsx(InputContainer, { children: _jsxs(LoginValidationText, { children: [_jsx(LoginValidationTextIcon, { children: _jsx(FontAwesomeIcon, { color: "#eb5757", width: 16, icon: faExclamationCircle }) }), _jsx(LoginValidationTextMessage, { children: _jsx(FormattedMessage, __assign({}, commonMessages.authenticationError)) })] }) })) : isPrivacy || isTerms || isTokenExpired ? (_jsx(InputContainer, { children: _jsxs(LoginValidationText, __assign({ option: true }, { children: [_jsx(LoginValidationTextIcon, { children: _jsx(FontAwesomeIcon, { color: "#3C8EFD", width: 16, icon: faExclamationCircle }) }), _jsx(LoginValidationTextMessage, { children: welcomeMessage })] })) })) : null, _jsxs(ForgetAndCreateAccount, { children: [_jsx(ForgetTextWrapper, __assign({ onClick: this.props.onForgotPassword }, { children: _jsx(P, __assign({ fontSize: 14, white: true, underline: true }, { children: "Forgot Password?" })) })), _jsx(CreateAnAccount, __assign({ onClick: this.createAnAccount }, { children: _jsx(P, __assign({ fontSize: 14, white: true, underline: true }, { children: "Create new account" })) }))] }), _jsx(AllRightWrapper, { children: _jsx(P, __assign({ fontSize: 14, white: true }, { children: "\u00A9 2006 - 2022 Appspotr AB, all rights reserved." })) })] }));
    };
    return LoginForm;
}(React.Component));
export default LoginForm;
